import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBackIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 18,
	viewBox: "0 0 10 18",
	fill: "#54476b",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M1.5 1.5C1.2 1.8 1.2 2.2 1.5 2.5L7 9L1.5 15.5C1.2 15.8 1.2 16.2 1.5 16.5C1.8 16.8 2.2 16.8 2.5 16.5L8.5 9.5C8.8 9.2 8.8 8.8 8.5 8.5L2.5 1.5C2.2 1.2 1.8 1.2 1.5 1.5Z" })
});
export default SvgBackIcon;
